export enum EEvents {
    SEND_PAGE_VIEW = 'wlaepSendPageView',
}

export type TEventBody = CustomEventInit<{
    name: string;
    data: Record<string, unknown>;
}>;

export const customEventService = {
    fire: (event: EEvents, body?: Record<string, unknown>): void => {
        const customEvent = new CustomEvent(event, { detail: body });

        window.dispatchEvent(customEvent);
    },
    subscribe: (event: EEvents, listener: EventListener) => {
        window.addEventListener(event, listener);
    },
    unsubscribe: (event: EEvents, listener: EventListener) => {
        window.removeEventListener(event, listener);
    },
};
